let isValidatingToken = false;
const requestQueue = [];

export const getIsValidatingToken = () => isValidatingToken;

export const setIsValidatingToken = val => {
  isValidatingToken = val;
};

// returns a promise, stores resolve/reject internally
export const enqueueRequest = config => {
  return new Promise((resolve, reject) => {
    requestQueue.push({ config, resolve, reject });
  });
};

export const flushQueue = (error, token) => {
  if (requestQueue.length === 0) return;

  while (requestQueue.length > 0) {
    const item = requestQueue.shift();
    if (!item) continue;

    const { config, resolve, reject } = item;

    if (token) {
      if (config?.headers) {
        config.headers['Authorization'] = `Bearer ${token}`;
      }
      resolve(config);
    } else {
      reject(error || new Error('Token validation failed. Session expired.'));
    }
  }
};
